var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackBrioniLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 68,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "30 20 140 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffffff",
    d: "M-.5-.5h200v200H-.5V-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M105.5 79.5a18.437 18.437 0 0 1 6 .5c-1.761 4.296-4.761 5.463-9 3.5a512.469 512.469 0 0 0 3-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M182.5 79.5c6.293-1.051 7.293.449 3 4.5-1.759.797-3.426.63-5-.5 1.13-1.122 1.797-2.456 2-4Zm-116-21c10.946-.84 14.78 4.16 11.5 15-3.64 7.473-9.14 13.14-16.5 17-.781 2.265.219 3.599 3 4 7.044-.746 11.544-4.413 13.5-11 1.263-2.107 3.097-3.107 5.5-3 .23 3.284-1.103 5.784-4 7.5 2.283.291 4.45-.209 6.5-1.5 1.5.167 2.333 1 2.5 2.5A159.72 159.72 0 0 1 76 106.5c-.089 4.21 1.744 5.043 5.5 2.5a268.17 268.17 0 0 0 18-21c2-.667 4-.667 6 0a237.38 237.38 0 0 0-15 20.5c4.05 1.156 7.717.323 11-2.5 2.913-12.258 10.58-18.591 23-19 1.987 1.319 3.154 3.152 3.5 5.5 3.192-3.18 7.026-5.18 11.5-6a17.774 17.774 0 0 1 6 4c4.344-2.46 9.011-3.46 14-3a12.93 12.93 0 0 1-.5 5 233.902 233.902 0 0 0-10.5 15c2.739 1.267 5.406 1.101 8-.5 8.247-4.911 15.247-11.245 21-19 2-.667 4-.667 6 0-8.584 11.334-14.917 23.834-19 37.5h-7a97.65 97.65 0 0 1 11-24l-.5-1c-6.647 7.242-14.814 11.076-24.5 11.5-1.054-1.388-1.22-2.888-.5-4.5a81.92 81.92 0 0 1 10-14 4.934 4.934 0 0 0 .5-3c-2.925-.04-5.591.793-8 2.5a209.28 209.28 0 0 0-15 18.5c-2.265 1.147-4.598 1.314-7 .5 6.401-6.657 11.401-14.157 15-22.5-7.534.837-12.367 4.837-14.5 12-4.684 8.264-11.517 11.431-20.5 9.5a26.585 26.585 0 0 0-2-3.5c-4.092 3.42-8.759 4.92-14 4.5-1.393-1.171-2.227-2.671-2.5-4.5-3.698 3.899-8.198 5.399-13.5 4.5-1.711-1.133-2.211-2.633-1.5-4.5a294.369 294.369 0 0 1 11.5-17l-1.5-1a328.806 328.806 0 0 1-15.5 7c-1.44 10.278-7.106 17.111-17 20.5a21.351 21.351 0 0 1-9.5 2.5c-6.454-.171-8.121-3.171-5-9 7.206-7.042 15.706-11.71 25.5-14v-3a143.748 143.748 0 0 1-13 3c-7.748-1.737-7.748-4.237 0-7.5a77.73 77.73 0 0 1 13 0c8.736-7.319 13.902-16.486 15.5-27.5-2.064-1.091-4.23-1.258-6.5-.5-18.67 9.67-32.17 24.17-40.5 43.5a240.704 240.704 0 0 0-7.5 20c-2.667 1.333-5.333 1.333-8 0 7.687-20.221 19.02-38.054 34-53.5 6.435-5.213 13.435-9.38 21-12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffffff",
    d: "M45.5 90.5a21.12 21.12 0 0 1 9 1c-3.257 2.38-6.924 3.38-11 3 .027-1.7.694-3.033 2-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffffff",
    d: "M119.5 89.5c4.47-.47 4.97.53 1.5 3a8.43 8.43 0 0 0-.5 4c1.175-.219 2.175.114 3 1-2.76 6.428-7.426 10.761-14 13-2.239-.074-3.239-1.241-3-3.5 2.247-7.41 6.58-13.243 13-17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffffff",
    d: "M55.5 98.5c1.175-.219 2.175.114 3 1-4.757 9.543-12.424 14.876-23 16 .471-4.003 2.471-7.169 6-9.5a143.243 143.243 0 0 1 14-7.5Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackBrioniLogo);
export default __webpack_public_path__ + "static/media/blackBrioniLogo.c7a18256a519412e985dfa4c6dce48d8.svg";
export { ForwardRef as ReactComponent };